import { CSSProperties, ReactElement } from 'react';
import { AnyObject } from '../../common/interfaces';

export interface CustomInputProps {
  value: Date | null;
  onClick: () => void;
  id: string;
}

export interface MonthsControlProps {
  value: number;
  onChange: (monthsValue: number) => void;
  disabled: boolean;
}

export interface ControlledInputProps {
  children: ReactElement;
  onButtonClick: (actionType: ActionType) => void;
  className: string | null;
  prefixId?: string;
  style?: CSSProperties;
}

export type ActionType = 'subtraction' | 'addition';

export interface ConfigurationFromPdfProps {
  createVehicleOffer: (dataToSend: AnyObject, files: File[], isAdditionalFieldsShown: boolean) => void;
  closeAlert: () => void;
  refreshList: () => void;
}

export interface IDistance {
  name: string;
  crmFieldType: number;
  value: number | null;
}

export enum SaveTypes {
  SaveForLater = 'saveForLater',
  RequestLeasingOffer = 'requestLeasingOffer'
}

export enum ConfigurationFromPdfFieldNames {
  Driver = 'driverId',
  OldCar = 'uds_altes_fahrzeugid',
  ResponsiblePerson = 'uds_kstverantw',
  CarBrand = 'uds_carbrandid',
  CarModel = 'uds_carmodelid',
  Variant = 'uds_modellspezifikation',
  FuelType = 'uds_enginetypecode',
  CarPolicy = 'uds_carpolicy',
  DriverLevel = 'uds_carpolicynutzer'
}

export interface CheckDriversCarsProps {
  driverId: string;
  successCallback: () => void;
  setMaxConfigurationsNumberReached?: () => void;
}
